import { Config } from 'tailwindcss';

export const theme = {
  extend: {
    colors: {
      // Actions
      'action-background': '#FFE3D5',
      'action-primary': '#FF732E',
      'action-primary-text': '#FFFFFF',
      'action-primary-disabled': '#ACACAC',
      'action-secondary': '#FFFFFF',
      'action-secondary-text': '#FF732E',
      'action-tertiary-text': '#FF732E', // Tertiary actions are text only
      'action-tertiary-disabled': '#8E8E8E',
      'select-background': '#FFFFFF',
      'select-hover': '#FFE3D5',
      'select-text': '#000000',
      'select-selected-background': '#FFE3D5',
      'select-selected-hover': '#FFE3D5',
      'select-selected-text': '#FF732E',
      // Severity levels
      'severity-critical-base': '#B91C1C',
      'severity-critical-secondary-base': '#DC8D8D',
      'severity-critical-background': '#F1D2D2',
      'severity-high-base': '#DF3232',
      'severity-high-secondary-base': '#EF9898',
      'severity-high-background': '#FCEAEA',
      'severity-medium-base': '#FF5400',
      'severity-medium-secondary-base': '#FFA980',
      'severity-medium-background': '#FFEEE5',
      'severity-low-base': '#593922',
      'severity-low-secondary-base': '#AC9C90',
      'severity-low-background': '#E2D2C4',
      'severity-informational-base': '#608895',
      'severity-informational-background': '#EBF8FE',
      'severity-unknown-base': '#6E6E6E',
      'severity-unknown-background': '#F2F2F2',
      // Feedback
      'positive-base': '#3D9F24',
      'positive-background': '#CEE1C9',
      'neutral-base': '#100868',
      'neutral-background': '#E1EBFE',
      'neutral-hover': '#534BAF',
      'negative-base': '#DF3232',
      'negative-background': '#FCEAEA',
      // System status
      'success-base': '#3D9F24',
      'success-background': '#CEE1C9',
      'error-base': '#DF3232',
      'error-background': '#FCEAEA',
      // Greyscale
      'darkest-gray': '#444444',
      'darker-gray': '#ACACAC',
      'dark-gray': '#D9D9D9',
      'light-gray': '#E9E9E9',
      'lighter-gray': '#F2F2F2',
      'lightest-gray': '#F3F4F6',
      'plerion-burnt-violet': '#150720', // rgb(21, 7, 32);
      'overlay-base': '#00031f',
      'content-muted': '#6b7280',
      'link-base': '#100868',
      'link-hover': '#534BAF',
      // Charts
      'chart-red': '#F0596B',
      'chart-blue': '#3E9BB5',
      'chart-purple': '#54375F',
      'chart-pink': '#FFAEB8',
      'chart-green': '#A7EDCC',
      'chart-teal': '#47C1E1',
      'chart-indigo': '#A4ADD7',
      'chart-orange': '#FBAA9C',
      'chart-yellow': '#FEDDAC',
      'chart-light-green': '#82ca9d',
      // Tabs
      'background-tabs': '#F3F4F6',
      'tabs-border': '#D1D5DB',
      // Table
      'table-border': '#D9D9D9', // dark-gray
      // Badges
      'badge-default-background': '#E1EBFE',
      'badge-good-background': '#CEE1C9',
      'badge-warning-background': '#FBF1C0',
      'badge-bad-background': '#FCEAEA',
      'badge-info-background': '#EBF8FE',
      'badge-neutral-background': '#E9E9E9',
      // Legacy
      'br-red': '#d64045',
      'br-green': '#218380',
      'br-yellow': '#ffbc42',
      'br-primary': '#192D38',
      'br-secondary': '#89BFC7',
      'br-deep-purple': '#45415D',
      'br-dark-blue': '#192D38',
      'br-light-grey': '#D8DEE2',
      'br-blue': '#89BFC7',
      'br-blue-grey': '#8490A0',
      'br-teal': '#B3E0E6',
      'br-accent': '#55BEDB',
    },
    fontFamily: {
      sans: ['Archivo', 'sans'],
      display: ['Archivo', 'sans'],
      body: ['Archivo', 'sans'],
    },
    spacing: {
      xxs: '4px',
      xs: '5px',
      sm: '8px',
      '15px': '15px',
      md: '16px',
      lg: '24px',
      xl: '30px',
      xxl: '64px',
      xxxl: '80px',
    },
    borderRadius: {
      badge: '5px',
      xl: '10px',
      '2xl': '15px',
      '2.5xl': '20px',
      '3xl': '30px',
    },
    boxShadow: {
      action: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
  },
} satisfies Config['theme'];
